module.exports = __webpack_public_path__ + "img/logo beta white.97330cda.svg";